module.exports = __webpack_public_path__ + "static/img/sence2.d5e65c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/media5/sence2.png
// module id = J8De
// module chunks = 7